// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-messages-panel{margin-top:10px}.group-messages-panel .group-messages-loader{position:relative;left:calc(50% - 20px);top:40vh}.group-messages-panel .send-new-group-message button{margin-left:30px}.group-messages-panel .title-eva{text-align:left;font-family:\"GothamSSm-Medium\",Arial,sans-serif;font-size:20px;font-weight:500;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#4a4a4a;margin:0;padding-top:35px}\n", ""]);
// Exports
module.exports = exports;
